import styled from "styled-components";


export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const DocumentsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const DocumentContent = styled.div``;
export const DocumentContentHead = styled.div``;
export const DocumentContentTable = styled.div``;

export const DocumentAction = styled.div`
  height: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const DocumentContentPagination = styled.div``;